import isEmail from 'validator/lib/isEmail'
import { FieldFormatterFn, SkipChangeFn } from '../index'

export const notNumber: SkipChangeFn = (value) => /[^0-9+]/g.test(value.replace(/[-()\s]/g, ''))

export const phoneFormatter: FieldFormatterFn = (value) => {
  const raw = value.replace(/[-()\s]/g, '')

  if (/^\+/.test(raw)) return { raw, formatted: raw }

  const formatted = raw.replace(/(^\d{1,3})(\d*)$/g, (_, first, rest) => {
    const end = rest.length > 3 ? `${rest.slice(0, 3)}-${rest.slice(3)}` : rest

    if (!end) return first
    return `(${first}) ${end}`
  })

  return { raw, formatted }
}

export const validators: Record<
  'phone' | 'email' | 'none',
  {
    format?: FieldFormatterFn
    skip?: SkipChangeFn
    pattern?: string
  }
> = {
  phone: {
    skip: notNumber,
    // If we want stronger validation, it would be better to use `libphonenumber-js`
    pattern: '^\\d{10,20}$|^(\\+1 ?)?\\(?\\d{3}\\)? ?\\d{3}(-| )?\\d{4}$',
  },
  email: {
    pattern: '[^@\\s]+@[^@\\s]+\\.[^@\\s]+',
  },
  none: {},
}

// Same check as the BFF's @IsEmail() (after its trim), which the native type="email" + pattern above is looser than
export const isValidEmail = (value: string) => isEmail(value.trim())
